<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full" v-if="!is_on_create">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="text" v-model="filters['search']" class="w-full"  />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">From</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['date-from']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['date-from']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">To</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['date-to']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['date-to']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select v-model="filters['status']" :options="statusList" name="status"/>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full" v-if="!customerId">
              <label class="text-sm opacity-100 text-bold">Account Handler</label>
              <v-select name="staffs" :closeOnSelect="false" :clearable="false"
                v-model="filters['account-handler']" :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="option => option.value" label="name" multiple />
            </div>
          </div>
          
          <div class="vx-row mt-4">
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full" v-if="!customerId">
              <label class="text-sm opacity-100 text-bold">Industrial Sector</label>
              <v-select v-on:input="onChangeIndustrySector" name="industry_sectors" :closeOnSelect="false" :clearable="false"
                v-model="filters['sector']" :options="industry_sectors" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="option => option.value" label="name" multiple />
            </div>
            <!-- <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Industrial Sub Sector</label>
              <v-select name="industry_sub_sectors" :closeOnSelect="false" :clearable="false" v-model="filters['sub-sector']"
                :options="industry_sub_sectors" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.id" label="name"
                multiple />
            </div> -->
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full" v-if="!customerId">
              <label class="text-sm opacity-100 text-bold">Customer Sources</label>
              <v-select v-on:input="onChangeCustomerSource" name="customer_sources" :closeOnSelect="false" :clearable="false"
                v-model="filters['source']" :options="customer_sources" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                :reduce="option => option.value" label="name" multiple />
            </div>
            <!-- <div class="vx-col md:w-1/5 sm:w-1/2 w-full mt-2">
              <label class="text-sm opacity-100 text-bold">Customer Sub Sources</label>
              <v-select name="customer_sub_sources" :closeOnSelect="false" :clearable="false" v-model="filters['sub-source']"
                :options="customer_sub_sources" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.id" label="name"
                multiple />
            </div> -->
          </div>

        </vx-card>
      </div>
    </div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card v-if="!is_on_create" title="SAMPLE ORDERS" >
          <template slot="actions">
            <div class="flex">
              <excel-download :name="customerId ? 'customer-sample-orders-sheet' : 'sample-orders-sheet'" :filters="{...filters, ...fixed_filters_for_export}"/>
              <vs-button v-can="'create-edit-sample-order'" @click="onClickCreateNewOrder" class="mr-4" color="primary" type="filled">Create new order</vs-button>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="customer-sample-orders-table" v-can="'view-sample-order'" :max-items="(meta.per_page) ? meta.per_page : 10" :data="staff" @sort="handleSort"   :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%" sort-key="created_at">ORDER DATE</vs-th>
                <vs-th width="10%">CREATED BY</vs-th>
                <vs-th width="10%" sort-key="sample_order_code">ORDER CODE</vs-th>
                <vs-th width="10%" >CUSTOMER ACCOUNT NUMBER</vs-th>
                <vs-th width="10%">CUSTOMER COMPANY</vs-th>
                <vs-th width="15%" >FINISHED PRODUCTS</vs-th>
                <vs-th width="10%" >STATUS</vs-th>
                <vs-th width="10%" >ORDER TYPE</vs-th>
                <vs-th width="8%" >SAMPLE QUOTE CODE</vs-th>
                <vs-th width="7%" class="" v-can="'create-edit-sample-order'">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr   style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].created_at">
                    {{__dateTimeFormatterToDate(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td :data="data[indextr].created_by">
                    {{ data[indextr].created_by || 'N/A' }}
                  </vs-td>

                  <vs-td :data="data[indextr].sample_order_code">
                    {{ data[indextr].sample_order_code}}
                  </vs-td>

                  <vs-td>
                    
                    <span v-if="data[indextr].customer">
                      <HyperLink :id="data[indextr].customer.id" type="customer">{{ data[indextr].customer.account_number }}</HyperLink>
                    </span>
                    <span v-else>
                      {{ data[indextr].customer_lead.code || ''}}
                    </span>
                    
                  </vs-td>

                  <vs-td>
                    <span v-if="data[indextr].customer">
                      <HyperLink :id="data[indextr].customer.id" type="customer">{{ data[indextr].customer.company_name }}</HyperLink>
                    </span>
                    <span v-else>
                      {{ data[indextr].customer_lead.company_name || data[indextr].customer_lead.code}}
                    </span>
                  </vs-td>


                  <vs-td :data="data[indextr].formulations">
                    <span v-if="data[indextr].formulation_items.length > 0" v-for="item in data[indextr].formulation_items" :key="item.id">
                      <a>{{ item.formulation_code }}</a> ,
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip transparent :color="projectBriefColorFactory(tr.status.id)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <vs-chip style="border-radius: 0" transparent :color="isChargeable(data[indextr]) ? 'success' : 'warning'">
                      {{ isChargeable(data[indextr]) ? 'Chargeable' : 'Free of Charge' }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <span class="text-primary cursor-pointer" @click.stop="onClickSampleQuote(data[indextr].sale_quote.id)">
                      {{ data[indextr].sale_quote.quote_code }}
                    </span>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="mr-2" text="View Order" position="left">
                        <vs-button @click.stop="onClickViewSampleOrder(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="['Requested'].includes(data[indextr].status.name)" v-can="'create-edit-sample-order'" class="mr-2" text="Update Order" position="left">
                        <vs-button @click.stop="onClickCustomerSiteUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-sample-order'" class="mr-2" text="Create Invoice" position="left">
                        <vs-button @click.stop="onClickCreateInvoice(data[indextr].id)"
                                   size="small" color="success" type="border" icon-pack="feather" icon="icon-plus"></vs-button>
                      </vx-tooltip>

                    </div>
                  </vs-td>

                 <template class="expand-user" slot="expand">
                   <div class="con-expand-users w-full">

                     <div class="con-btns-user flex items-center justify-between hidden">
                       <div class="con-userx flex items-center justify-start">
                       </div>
                       <div class="flex mb-4">
                         <vs-button v-if="[1].includes(tr.status.id)" @click="onClickStatusChangeConfirm(tr.id, 'dispatch')" type="border" size="small" icon-pack="feather" icon="icon-log-in" color="warning" class="mr-2">Dispatched Order</vs-button>
                         <vs-button v-if="[1].includes(tr.status.id)" @click="onClickStatusChangeConfirm(tr.id, 'refuse')"  type="border" size="small" icon-pack="feather" icon="icon-alert-triangle" color="danger" class="mr-2">Refuse Order</vs-button>
                         <vs-button v-if="[1].includes(tr.status.id)" @click="onClickStatusChangeConfirm(tr.id, 'cancel')" type="border" size="small" icon-pack="feather" icon="icon-x" color="danger" class="mr-2">Cancel Order</vs-button>
                         <vs-button v-if="[2].includes(tr.status.id)" @click="onClickStatusChangeConfirm(tr.id, 'deliver')" type="border" size="small" icon-pack="feather" icon="icon-check" color="primary" class="mr-2">Sample dispatched</vs-button>
                       </div>
                     </div>

                     <div class="vx-row mb-1">
                       <div class="vx-col w-full">
                          <vs-table :data="tr.formulation_items" stripe class="mx-16">
                            <template slot="header">
                              <h4 class="mb-2">
                                Formulation Items
                              </h4>
                            </template>
                            <template slot="thead">
                              <vs-th width="25%">FORMULATION CODE</vs-th>
                              <vs-th width="35%">FORMULATION NAME</vs-th>
                              <vs-th width="15%">PRICE (GBP/KG)</vs-th>
                              <vs-th width="15%">QUANTITY (GRAMS)</vs-th>
                              <vs-th width="15%">NET VALUE (GBP)</vs-th>
                              <!-- <vs-th width="20%">ACTION</vs-th> -->
                            </template>

                            <template slot-scope="{data}">
                              <vs-tr :ref="`table_row_${indextr}`" :key="indextr" v-for="(tr_fg, indextr) in data">

                                <vs-td :data="data[indextr].formulation_code">
                                  {{ data[indextr].formulation_code }}
                                </vs-td>
                                <vs-td :data="data[indextr].name">
                                  {{ data[indextr].name }}
                                </vs-td>
                                <vs-td :data="data[indextr].price">
                                  {{ Number(data[indextr].price).toFixed(2) }}
                                </vs-td>
                                <vs-td :data="data[indextr].quantity">
                                  {{ data[indextr].quantity }}
                                </vs-td>
                                <vs-td :data="data[indextr].quantity">
                                  {{ Number((data[indextr].quantity / 1000) * data[indextr].price).toFixed(2) }}
                                </vs-td>

                                <!-- <vs-td>
                                  <vx-tooltip class="" text="View formulation breakdown" position="left">
                                    <vs-button
                                      size="small" color="primary" type="border" icon-pack="feather"
                                      icon="icon-git-merge"></vs-button>
                                  </vx-tooltip>
                                </vs-td> -->
                                <!-- <template class="expand-user" slot="expand">
                                  <div class="con-expand-users w-full">
                                    <vs-table class="mt-8 mb-8 mx-8" :data="tr_fg.raw_material_items">

                                      <template slot="header">
                                        <h5 class="mb-4">Formulations breakdown</h5>
                                      </template>

                                      <template slot="thead">
                                        <vs-th width="10%">PRODUCT CODE</vs-th>
                                        <vs-th width="15%">PRODUCT NAME</vs-th>
                                        <vs-th width="10%">QUANTITY (GRAMS)</vs-th>
                                        <vs-th width="5%">SOL</vs-th>
                                        <vs-th width="5%">HALAL</vs-th>
                                        <vs-th width="5%">KOSHER</vs-th>
                                        <vs-th width="10%">STATUS</vs-th>
                                      </template>

                                      <template slot-scope="{data}">
                                        <vs-tr :key="index_rm_item" v-for="(tr_item, index_rm_item) in data">

                                          <vs-td>
                                            <span v-if="tr_item.company_product_code"> {{ tr_item.category }}-{{ tr_item.company_product_code }} </span>
                                            <span v-if="tr_item.formulation_code"> {{ tr_item.formulation_code }} </span>
                                          </vs-td>
                                          <vs-td :data="tr_item.company_product_name">
                                            {{ tr_item.company_product_name || '' }}
                                          </vs-td>

                                          <vs-td :data="tr_item.quantity_kg">
                                            {{ Number(tr_item.quantity_kg).toFixed(1) }}
                                          </vs-td>

                                          <vs-td :data="tr_item.dissolvable">
                                            {{ tr_item.dissolvable === 'Yes' ? 'S' : '' }}
                                          </vs-td>

                                          <vs-td :data="tr_item.halal_suitable">
                                            {{ suitableOrCertified(tr_item.halal_suitable, tr_item.halal_certified) }}
                                          </vs-td>

                                          <vs-td :data="tr_item.kosher_suitable">
                                            {{ suitableOrCertified(tr_item.kosher_suitable, tr_item.kosher_certified) }}
                                          </vs-td>

                                          <vs-td :data="tr_item.status">
                                            {{ tr_item.status }}
                                          </vs-td>
                                        </vs-tr>
                                      </template>
                                    </vs-table>
                                  </div>
                                </template> -->
                              </vs-tr>
                  
                            </template>
                          </vs-table>
                  
                       </div>
                     </div>

                   </div>
                 </template>

                </vs-tr>
              </template>


            </vs-table>

            <vx-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5"></vx-pagination>

          </div>
        </vx-card>
        <customer-cart-list v-on:back="refreshData($event)" v-if="is_on_create" v-bind:is_free_of_charge_sample="is_free_of_charge"/>
      </div>
    </div>
    <vs-popup title="Sample Order Pricing" :active.sync="active_charge_prompt" :buttons-hidden="true">
      <div class="text-center p-4">
        <p class="mb-6 text-lg">Is this sample order free of charge or chargeable?</p>
        <div class="flex justify-center" style="gap: 1rem;">
          <vs-button color="success" type="filled" @click="onSelectChargeType(false)">Chargeable</vs-button>
          <vs-button color="warning" type="filled" @click="onSelectChargeType(true)">Free of Charge</vs-button>
        </div>
      </div>
    </vs-popup>
    <update-customer-sample-order-pop-up ref="updateCustomerSampleOrderPopUp"/>
    <CreateSampleOrderInvoicePopUp ref="createSampleOrderInvoicePopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  const CustomerSourceRepository = RepositoryFactory.get('customer_source')
  import UpdateCustomerSampleOrderPopUp from '@/components/popups/customer/sample-orders/UpdateCustomerSampleOrderPopUp'
  import CustomerCartList from './CustomerCartList'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import router from "@/router";
  import flatPickr from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css'
  import { mapActions, mapGetters } from 'vuex';
  import CreateSampleOrderInvoicePopUp from '@/components/popups/customer/sample-orders/invoices/CreateSampleOrderInvoicePopUp.vue'
  import {defaultPagination, perPageList} from "@/constants/config";

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        customerId: '',
        is_on_create: false,
        statusList:[
          'Requested',
          'Dispatched',
          'Not Approved',
          'Delivered',
          'Cancelled',
        ],
        industry_sub_sectors: [],
        customer_sub_sources: [],
        perPage: defaultPagination,
        descriptionItems: perPageList,
        fixed_filters_for_export : { customer_ids: [ Number(this.$route.params.id)  ] },
        active_charge_prompt: false,
        is_free_of_charge: false,
        
      }
    },
    components: {
      'v-select': vSelect,
      UpdateCustomerSampleOrderPopUp,
      CustomerCartList,
      flatPickr,
      CreateSampleOrderInvoicePopUp
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
      this.setFilterId('sample_orders_list_filters',['search','date-from','date-to','status','account-handler','sector','source'])
      if(!!this.$route.query.create) {
        this.is_on_create = true
      } else {
        await this.fetchIndustrySections()
        await this.fetchCustomerSources()
        await this.fetchStaffs()
      }
    },
    methods: {
      ...mapActions([ 'fetchIndustrySections', 'fetchCustomerSources', 'fetchStaffs']),
      async refreshData () {
        this.is_on_create = false
        await this.loadStaff()
        if(!!localStorage.getItem('redirect_url')){
          this.$router.push(localStorage.getItem('redirect_url'))
          localStorage.removeItem('redirect_url')
        }
      },

      async loadStaff() {
        await this.$vs.loading()
        try {
          if(this.customerId) {
            const {data} = await CustomerRepository.getListOfSamples(this.customerId, this.page, this.filterQuery, this.perPage, this.sort)
            this.staff =  data.data
            this.meta = data.meta
          } else {
            const {data} = await CustomerRepository.getAllListOfSamples(this.page, this.filterQuery, this.perPage, this.sort)
            this.staff =  data.data
            this.meta = data.meta
          }
        } catch (error) {
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close()
      },

      async onClickCustomerSiteUpdate (id) {
        await this.$refs.updateCustomerSampleOrderPopUp.openPopup(id)
      },
      async onClickViewSampleOrder(id) {
        if(this.customerId) {
          await this.$router.push({path: `/pages/sample-orders/${id}?back_customer=${this.customerId}`})
        } else {
          await this.$router.push({path: `/pages/sample-orders/${id}`})
        }
      },
      async onSelectChargeType(isFreeOfCharge) {
        this.is_free_of_charge = isFreeOfCharge
        this.active_charge_prompt = false
        this.is_on_create = true
      },
      onClickCreateNewOrder() {
        if(this.customerId){
        this.active_charge_prompt = true
        }else {
          this.is_on_create = true
        }
      },

      filterQueryUpdate (){
        this.loadStaff()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }
      },
      changePage(index) {
        this.page = 1
        this.perPage = this.descriptionItems[index]
      },
      isChargeable(item) {
        if (!item) return false
        if (item.is_free_of_charge === true || item.is_free_of_charge == 1) return false
        return !!(item.is_chargeable == 1 || item.is_chargeable === true)
      },
      projectBriefColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning';
          case 2:
            return 'primary';
          case 3:
            return '#f05945';
          case 4:
            return '#f58634';
          case 5:
            return '#206a5d';
        }
      },
      onClickFormula(id) {
        this.$router.push({path: `/pages/formulations/${id}`})
      },
      onClickSampleQuote(id) {
        router.push(`/pages/sales-quote?id=${id}`)
      },
      onClickStatusChangeConfirm(id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeSampleOrderStatus,
          parameters: [id, status]
        })
      },
      async onChangeSampleOrderStatus(params){
        this.$vs.loading()
        try {
          await CustomerRepository.statusChangeCustomerSampleOrders(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.loadStaff()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      suitableOrCertified(suitable, certified) {
        let text = ''
        if (suitable === 'Yes') {
          text = text + ' S'
        }
        if (certified === 'Yes') {
          text = text + ' C'
        }
        return text
      },
      async onChangeIndustrySector(ids) {
        this.filters['sub-sector'] = null
        if (ids.length === 0) return null
        try {
          const { data } = (await CustomerRepository.getIndustrySubSectors({ ids: ids })).data
          this.industry_sub_sectors = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      async onChangeCustomerSource(ids) {
        this.filters['sub-source'] = null
        if (ids.length === 0) return null
        try {
          const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: ids })).data
          this.customer_sub_sources = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      async onClickCreateInvoice(sample_order_id) {
        await this.$refs.createSampleOrderInvoicePopUp.openPopup(sample_order_id)
      }
    },
    computed: {
      ...mapGetters(['industry_sectors', 'customer_sources', 'staffs'])
    },
    watch : {
      page(){
        this.loadStaff()
      },
      perPage() {
        this.loadStaff()
      },
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
